import { Component, Input } from '@angular/core';
import { StandardReports } from '../../interfaces/standard-reports.interface';

@Component({
    selector: 'app-overview-reporting-card',
    templateUrl: './overview-reporting-card.template.html',
})
export class OverviewReportingCardComponent {
    @Input() standardReports: StandardReports[] = [];
}
